import Vue from 'vue';
import { numericTextDirective } from './directives';

Vue.directive('numeric-text', numericTextDirective);
